// extracted by mini-css-extract-plugin
export default {"cardHeader":"DepartmentManagement_cardHeader__rewo8","cardHeaderIcon":"DepartmentManagement_cardHeaderIcon__sl5VF","createButton":"DepartmentManagement_createButton__78Vsj"};